import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ErrorTestHttpService } from 'app/shared/requests/services/error-test-http.service';

@Component({
  selector: 'app-error-handling-test',
  encapsulation: ViewEncapsulation.Emulated,
  templateUrl: './error-handling-test.component.html',
  standalone: false,
})
export class ErrorHandlingTestComponent {
  constructor(
    errorService: ErrorTestHttpService,
    private route: ActivatedRoute
  ) {
    if (this.route.snapshot.paramMap.get('code')) {
      const errorCode = this.route?.snapshot?.paramMap?.get('code');
      if (errorCode) {
        errorService.getError(+errorCode).subscribe();
      }
    }
  }
}
